import React from 'react';
import { Redirect } from 'expo-router';

export default function DebugRoute() {
  if (!__DEV__) {
    return <Redirect href="/(app)" />;
  }

  // O laboratório só é carregado em desenvolvimento, inclusive por link direto.
  const DebugScreen = require('@/components/development/DebugScreen').default;
  return <DebugScreen />;
}
